/**
 * 模块说明：大目录管理
 */
import { Service } from '@/tools'
export class PartialServer<T extends TOrder.OrderPartial> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.OrderPartial}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：分页查询部分放单规则
   * /api/order/partial/v1/partialRulePage
   */
  partialRulePage = <K extends T['ApiPartialRulePage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPartialRulePage', data)
  /**
   * 功能：创建部分放单规则
   * /api/order/partial/v1/partialRuleAdd
   */
  partialRuleAdd = <K extends T['ApiPartialRuleAdd']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPartialRuleAdd', data)
  /**
   * 功能：编辑部分放单规则
   * /api/order/partial/v1/partialRuleUpdate
   */
  partialRuleUpdate = <K extends T['ApiPartialRuleUpdate']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPartialRuleUpdate', data)
  /**
   * 功能：启用-禁用-关闭部分放单规则
   * /api/order/partial/v1/partialRuleEnableDisClo
   */
  partialRuleEnableDisClo = <K extends T['ApiPartialRuleEnableDisClo']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiPartialRuleEnableDisClo', data)
  /**
   * 功能：禁用-关闭部分放单规则
   *  /api/order/partial/v1/partialRuleDisable
   */
  partialRuleDisable = <K extends T['ApipartialRuleDisable']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApipartialRuleDisable', data)

  /**
   * 功能：启用-关闭部分放单规则
   *  /api/order/partial/v1/partialRuleEnable
   */
  partialRuleEnable = <K extends T['ApiPartialRuleEnable']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPartialRuleEnable', data)
  /**
   * 功能：回显数据-查看
   * /api/order/partial/v1/partialRuleFindById
   */
  partialRuleFindById = <K extends T['ApiPartialRuleFindById']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPartialRuleFindById', data)
  /**
   * 功能：查询部分放单规则明细
   * /api/order/partial/v1/partialRuleDetail
   */
  partialRuleDetail = <K extends T['ApiPartialRuleDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPartialRuleDetail', data)

  /**
   * 功能：关闭部分放单
   * /api/order/partial/v1/partialRuleClose
   */
  partialRuleClose = <K extends T['ApiPartialRuleClose']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPartialRuleClose', data)
  /**
   * 功能：部分放单审批通过
   * /api/order/partial/v1/partialApproved
   */
  partialApproved = <K extends T['ApiPartialApproved']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPartialApproved', data)
  /**
   * 功能：部分放单审批拒绝
   * /api/order/partial/v1/partialApprovedRefuse
   */
  partialApprovedRefuse = <K extends T['ApiPartialApprovedRefuse']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiPartialApprovedRefuse', data)
}
